import { Colors } from "../../consts/Colors";
import FONTS from "../../consts/Fonts";
import { tags } from "../../consts/Tags";
import ButtonRounded from "../global/buttons/ButtonRounded";

export default class DebriefPanel extends Phaser.GameObjects.Container {
   constructor(scene) {
      super(scene, 0, 0, []);

      this.soundManager = scene.soundManager

      this.scene = scene;
      scene.add.existing(this);

      // Ajout du fond
      let background = this.scene.add.rectangle(0, 0, 1165, this.scene.height, Colors.Elmt.LightGrey).setOrigin(0);
      this.add(background);

      // Ajout de la bande
      let bande = this.scene.add.rectangle(0, 0, 80, background.height, Colors.Elmt.Blue).setOrigin(0);
      this.add(bande);

      // Ajout du titre
      let debrief = this.scene.add.text(160, 66, "DEBRIEF", {
         fontSize: '14px',
         fontFamily: FONTS.InterRegular,
         color: Colors.Text.Blue
      }).setOrigin(0)
      this.add(debrief);

      let line = this.scene.add.rectangle(160, 112, 925, 1, Colors.Elmt.DarkGrey).setOrigin(0);
      this.add(line);

      // Ajout du texte
      const configText = {
         fontSize: '24px',
         fontFamily: FONTS.Inter24Medium,
         color: Colors.Text.Black
      }

      let txt = "Lorsque vous voulez vérifier la véracité d’une information complexe, l’article scientifique est votre meilleur repère. Pour vous assurer de sa qualité, plusieurs étapes sont nécessaires :"
      let text = this.scene.add.text(160, 140, txt, configText).setOrigin(0).setWordWrapWidth(925);
      this.add(text);

      let txts = [
         "<class=\"Inter24Bold_Orange\">Vérifier la structure :</class> un article sérieux doit comporter des sections précises (résumé, mots clés, introduction, méthodologie, résultats, discussion, conclusion et bibliographie). Si ces blocs sont absents, la rigueur de l'étude est douteuse.",
         "<class=\"Inter24Bold_Orange\">Analyser la méthodologie :</class> c'est le cœur de l'article. Elle doit détailler comment les chercheurs ont travaillé pour que n'importe qui puisse reproduire l'expérience.",
         "<class=\"Inter24Bold_Orange\">Traquer les erreurs scientifiques :</class> une confusion sur des mécanismes de base, comme la respiration ou la croissance des plantes, est un signal d'alerte immédiat sur l'incompétence (ou la malhonnêteté) de l'auteur.",
         "<class=\"Inter24Bold_Orange\">Passer la bibliographie au crible :</class> ne croyez pas les références sur parole. Vérifiez si les articles cités existent réellement et s'ils proviennent de sources officielles.",
         "<class=\"Inter24Bold_Orange\">S’appuyer sur la validation par les pairs :</class> un article fiable a été relu et critiqué par d'autres scientifiques indépendants avant d'être publié."
      ]
      let Y = text.y + text.height + 24;
      txts.forEach((txt, index) => {
         let bullet = this.scene.add.circle(200, Y + 16, 6, Colors.Elmt.Orange);
         this.add(bullet);

         let text = this.scene.add.rexTagText(240, Y, txt, {...configText, tags: tags, wordWrap: {width: 847}}).setOrigin(0);
         this.add(text);

         Y += text.height + 24;
      })

      txt = "C’est la combinaison de ces observations qui vous permet de confirmer qu'un document est une preuve solide et non une manipulation."
      text = this.scene.add.text(160, Y, txt, configText).setOrigin(0).setWordWrapWidth(925);
      this.add(text);

      // Ajout du bouton de fermeture
      let closeBtn = new ButtonRounded(this.scene, background.width/2 + bande.width/2, Y + text.height + 48, {
         text: "Continuer",
         color: Colors.Elmt.Orange,
         textColor: Colors.Text.White,
         hoverColor: Colors.Elmt.Blue,
      })
      closeBtn.y += closeBtn.height/2;
      this.add(closeBtn);

      closeBtn.setClickFunction(() => {
         this.animOut(() => {
            this.scene.closeDebrief()
         })      
      })

      this.setSize(background.width, background.height);
   }

   animIn() {
      this.x = this.scene.width;

      this.soundManager.playOnce('PaperSlide4')

      this.scene.tweens.add({
         targets: this,
         x: this.scene.width - this.width,
         duration: 500,
         ease: 'Cubic.easeInOut'
       });

   }

   animOut(endFunc) {
      this.soundManager.playOnce('PaperSlide4')
      this.scene.tweens.add({
         targets: this,
         x: this.scene.width,
         duration: 500,
         ease: 'Cubic.easeInOut',
         onComplete: () => {
            // Animation complete
            if(endFunc) endFunc();
         }
       });
   }
}